// extracted by mini-css-extract-plugin
module.exports = {"Image":"ValidarEntrada_Image__2lZTF","Title":"ValidarEntrada_Title___JGHc"};